module.exports = __webpack_public_path__ + "static/media/close-modal.056afab6.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/close-modal.svg
// module id = 1171
// module chunks = 0